const CONTRACT_STATE = {
    proposal: 'PROPOSAL',
    valid: 'VALID',
    postponed: 'POSTPONED',
    finished: 'FINISHED',
    valid_unsigned: 'PlatnáNepodepsaná',
    proposal_esign: 'ESIGN',
}

export default CONTRACT_STATE

export enum ContractState {
    Proposal = 'PROPOSAL',
    Valid = 'VALID',
    Postponed = 'POSTPONED',
    Finished = 'FINISHED',
    ValidUnsigned = 'PlatnáNepodepsaná',
    ProposalEsign = 'ESIGN',
}
